import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { EnvironmentConfig, ENVIRONMENT_CONFIG } from '@ipreo/northstar';
import { map } from 'rxjs/operators';
import { WireNode, Wire } from '../types/wire.types';
import { PlatformType } from '../types/muni-environment';
import { WiresApiResponse, WireApiResponse } from './wire.service.types';

interface WiresServiceConfig {
  getWiresUrl: (dealId: string) => string;
  getWireUrl: (wireId: number | string, dealId?: string) => string;
}

@Injectable()
export class WiresService {
  private apiHost: string;
  private platform: PlatformType;
  // TODO: Refactor when MUNI API v2 is ready
  private readonly platforms: { [key: string]: WiresServiceConfig } = {
    polaris: {
      getWiresUrl: (dealId: string) =>
        `${this.apiHost}/api/v2/issues/${dealId}/wires`,
      getWireUrl: (wireId: string, _dealId?: string) =>
        `${this.apiHost}/api/v2/wires/${wireId}`,
    },
    buyside: {
      getWiresUrl: (dealId: string) =>
        `${this.apiHost}/v1/deals/fixed-income/municipal/${dealId}/wires`,
      getWireUrl: (wireId: string, dealId?: string) =>
        `${this.apiHost}/v1/deals/fixed-income/municipal/${dealId}/wires/${wireId}`,
    },
  };

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.platform = (config.params.platform || 'polaris') as PlatformType;
    this.apiHost = config.params.apiHost as string;
  }

  public loadWires(dealId: string): Observable<WireNode[]> {
    const url = this.config.getWiresUrl(dealId);

    return this.http
      .get<WiresApiResponse>(url, { observe: 'response' })
      .pipe(
        map((res: HttpResponse<WiresApiResponse>) => {
          if (res.body.error) {
            throw res.body.error.message;
          }

          return res.body.wires;
        })
      );
  }

  public loadWire(wireId: number, dealId?: string): Observable<Wire> {
    const url = this.config.getWireUrl(wireId, dealId);

    return this.http
      .get<WireApiResponse>(url, { observe: 'response' })
      .pipe(
        map((res: HttpResponse<WiresApiResponse>) => {
          if (res.body.error) {
            throw res.body.error.message;
          }

          return res.body as Wire;
        })
      );
  }

  private get config() {
    return this.platforms[this.platform];
  }
}
